export default __webpack_public_path__ + "assets/icons/personalUs.2f394879.svg";